import { Breadcrumb, Button, Card, Col, DatePicker, Flex, Layout, Row, Select, Space, Table } from "antd";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import dayjs from "dayjs";
import moment from "moment";
import FormItem from "antd/es/form/FormItem";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import TableAntd from "components/elements/Table";
import LeaveRightsModal from "./reportModal/LeaveRightsModal";

const LeaveRightsGroupComponent = ({
    reportTableLeaveRights = [],
    departmentOptions = [],
    employeeOptions = [],
    showReport,
    pagination,
    initialValues,
    onChange = () => { },
    exportLeaveQuotaReport = () => { },
    handleSearch = () => { },
    isModalOpen = false,
    setIsModalOpen = () => { },
    showModal = () => { }
}) => {
    const { t, i18n } = useTranslation();

    function formatDate(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "DD MMM YYYY" : `DD MMMM ${date.year() + 543}`);
    }

    function formatTime(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "HH:mm" : `HH:mm น.`);
    }
    // console.log("ma yaaaaaaaaaaang", reportTableLeaveRights);
    const calculateWorkDuration = (startDateStr) => {
        const startDate = moment(startDateStr);

        const currentDate = moment();

        const years = currentDate.diff(startDate, 'years');
        startDate.add(years, 'years');

        const months = currentDate.diff(startDate, 'months');
        startDate.add(months, 'months');

        const days = currentDate.diff(startDate, 'days');

        return `${years} ปี ${months} เดือน ${days} วัน`;
    }

    const columns = [
        {
            title: <div className="text-table">{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 100,
            render: (_, record, idx) => {
                return <span style={{ color: "#667085" }}>{(pagination.page) * pagination.size + idx + 1}</span>;
            },
        },
        {
            title: <div className="text-table">{t('employee-name')}</div>,
            dataIndex: "txnRemainingLeave",
            key: "txnRemainingLeave",
            align: "left",
            width: 200,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record.nameEn + " " + record.surNameEn;
                }
                return record.name + " " + record.surName;
            },


        },
        {
            title: <div className="text-table">{t('employee.employment-date')}</div>,
            dataIndex: "probationDate",
            key: "probationDate",
            align: "left",
            width: 200,
            render: (_, record) => {
                return record?.probationDate ? formatDate(record?.probationDate) : "-";
            },

        },
        {
            title: <div className="text-table">{t('working-age')}</div>,
            dataIndex: "probationDateCal",
            key: "probationDateCal",
            align: "left",
            width: 250,
            render: (_, record) => {
                return record?.probationDate ? calculateWorkDuration(record?.probationDate) : "-";
            }

        },
        {
            title: <div className="text-table">{t('packing-date-0')}</div>,
            dataIndex: "employmentDate",
            key: "employmentDate",
            align: "left",
            width: 200,
            render: (_, record) => {
                return record?.employmentDate ? formatDate(record?.employmentDate) : "-";
            },



        },
        {
            title: <div className="text-table">{t('year-of-service')}</div>,
            dataIndex: "count",
            key: "count",
            align: "left",
            width: 200,
            render: (_, record) => {
                return record?.employmentDate ? calculateWorkDuration(record?.employmentDate) : "-";
            }
        },
        // {
        //     title: <div className="text-table">{t('paid-leave')}</div>,
        //     dataIndex: "index",
        //     key: "index",
        //     align: "center",
        //     width: 200,
        //     render: (_, record) => {
        //         return record.count;
        //     }

        // },
        // {
        //     title: <div className="text-table">{t('unpaid-leave')}</div>,
        //     dataIndex: "index",
        //     key: "index",
        //     align: "center",
        //     width: 200,

        // },
        // {
        //     title: <div className="text-table">{t('sick-leave-with-medical-certificate')}</div>,
        //     dataIndex: "index",
        //     key: "index",
        //     align: "center",
        //     width: 300,

        // },
        // {
        //     title: <div className="text-table">{t('paid-maternity-leave')}</div>,
        //     dataIndex: "index",
        //     key: "index",
        //     align: "center",
        //     width: 200,
        // },
        // {
        //     title: <div className="text-table">{t('unpaid-maternity-leave')}</div>,
        //     dataIndex: "index",
        //     key: "index",
        //     align: "center",
        //     width: 200,

        // },
        // {
        //     title: <div className="text-table">{t('take-annual-leave')}</div>,
        //     dataIndex: "index",
        //     key: "index",
        //     align: "center",
        //     width: 200,

        // },
        // {
        //     title: <div className="text-table">{t('training-leave')}</div>,
        //     dataIndex: "index",
        //     key: "index",
        //     align: "center",
        //     width: 200,

        // },
        // {
        //     title: <div className="text-table">{t('leave-for-sterilization')}</div>,
        //     dataIndex: "index",
        //     key: "index",
        //     align: "center",
        //     width: 200,

        // },
        // {
        //     title: <div className="text-table">{t('missing-work')}</div>,
        //     dataIndex: "index",
        //     key: "index",
        //     align: "center",
        //     width: 200,
        // }, 
    ];

    const [columnDynamic, setColumnDynamic] = useState(columns)

    useEffect(() => {
        if (reportTableLeaveRights) {
            let map = {};
            reportTableLeaveRights?.forEach?.(o => {
                o.txnRemainingLeave?.forEach(v => {
                    map[v.leaveTypeId] = {
                        "leaveTypeName": v.leaveTypeName,
                        "leaveTypeNameEn": v.leaveTypeNameEn,
                    }
                })
            })
            let temp = [...columns]
            for (const key in map) {
                (function (currentKey) {
                    temp.push({
                        title: <div className="text-table">{map[currentKey]?.leaveTypeName}</div>,
                        dataIndex: currentKey,
                        key: currentKey,
                        align: "center",
                        width: 200,
                        render: (_, record) => {
                            let model = record?.txnRemainingLeave?.find?.(o => o.leaveTypeId === currentKey);
                            if (model?.unlimited === 'Y') {
                                return "unlimited";
                            } else {
                                return model?.remainingLeaveDays
                                    ? model?.remainingLeaveDays + ' วัน ' + model?.remainingLeaveHour + ' ชั่วโมง'
                                    : '';
                            }
                        },
                    });
                })(key);
                // console.log("temp", temp);
                setColumnDynamic([...temp])
            }
        }
    }, [reportTableLeaveRights])

    const scrollX = columnDynamic.reduce((sum, column) => sum + (column.width || 0), 0);
    return (
        <MainLayout>
            <LeaveRightsModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} exportLeaveQuotaReport={exportLeaveQuotaReport} />
            <Space style={{ width: "100%", rowGap: 24 }} direction="vertical" >
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t('report.header') },

                        {
                            title: t('leave-rights-group'),
                        },
                        { title: t('report-on-leave-statistics-according-to-quota') }
                    ]} />
                    <h2>{t('report-on-leave-statistics-according-to-quota')}</h2>
                </Flex>
                <FormAntd
                    // form={form}
                    initialValues={{ ...initialValues }}
                    onFinish={handleSearch}
                // requiredMark={RequiredMark}
                // colon={false}
                >
                    <FormItem shouldUpdate={(prev, curv) => {

                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical style={{ rowGap: "24px" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        // mode="multiple"
                                                        label={t('organizational-structure')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                    // onChange={handleChange}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="year"
                                                        dateFormat={"YYYY"}
                                                        picker="year"
                                                        label={t('translation.year')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                    // defaultValue={moment('2023', 'YYYY')} // แสดงปี 2023 เป็นค่าเริ่มต้น
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t('warning_letter.label.employee')}
                                                        placeholder={t('common.pleaseSelect')}
                                                        size="large"
                                                    // options={employeeOptions}
                                                    />
                                                </Col>

                                            </Row>
                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>

                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>


                                    {showReport && (
                                        <Space direction="vertical" size={16}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                    <Flex gap={8}>
                                                        <DownloadIcon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>
                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <Space direction="vertical" size={8}>
                                                    <span style={{ fontSize: "1vw", fontWeight: "bold" }}>{t('report-on-leave-statistics-according-to-quota')}</span>
                                                    <TableAntd
                                                        columns={columnDynamic}
                                                        dataSource={reportTableLeaveRights}
                                                        rowKey={(record) => record.id}
                                                        scroll={{ x: scrollX }}
                                                        onChange={onChange}
                                                        pagination={pagination}
                                                        tableLayout="fixed"
                                                    />
                                                </Space>
                                            </Card>
                                        </Space>
                                    )}
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    );
}

export default LeaveRightsGroupComponent;
